import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownAZ } from "@fortawesome/pro-regular-svg-icons";

import { SpaceType } from "../../../../../store";

import { LetterSpaceNumberMarkerDecoration } from "./LetterSpaceNumberMarkerDecoration";

export class UppercaseSpaceLetterMarkerDecoration extends LetterSpaceNumberMarkerDecoration {
  textContent(space: SpaceType): string {
    if (!space) return '__SPACE_LETTER__';
    return super.textContent(space).toUpperCase();
  }

  Thumbnail() {
    return (
      <FontAwesomeIcon icon={faArrowDownAZ} />
    );
  }

  title = 'Upper case Space Letter';
}
